const intro = require('./components/intro');
const navScroll = require('./components/navScroll');
const introScroll = require('./components/introScroll');
const overlay = require('./components/overlay');
const slideshow = require('./components/slideshow');
const contact = require('./components/contact');
const sidebarNav = require('./components/sidebarNav');
const skillsScroll = require('./components/skillsScroll');
const Bugsnag = require('./services/Bugsnag');
require('./third-party/ga');

(function() {
    intro();
    navScroll();
    introScroll();
    overlay();
    slideshow();
    contact();
    sidebarNav();
    skillsScroll();

    Bugsnag.init()
})();



// WEBPACK FOOTER //
// ./resources/js/app.js